export default "__VITE_ASSET__b30b43ce__"